import { TimelineMax, TweenMax } from 'gsap';
import styled from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Image from '@/components/UI/Image';

const StoryDescribe = () => {
    const { useState, useEffect, isMobile, useLang } = useGlobal();
    const { t } = useLang('brandstory');
    let controller = null;

    useEffect(() => {
        if (isMobile) return;
        controller = new ScrollMagic.Controller();

        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.storyDesc', //触发元素
            offset: 500, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '100%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const timelineA1 = new TimelineMax();

        const tweenA1 = TweenMax.to(`.right_content .paraga`, 0.5, { opacity: 1, y: 0 });
        const tweenA2 = TweenMax.to(`.fullImgs`, 5, { scale: 1 });
        const tweenA3 = TweenMax.to(`.right_content .paragb`, 0.5, { opacity: 1, y: 0 });
        const tweenA4 = TweenMax.to(`.right_content .paragc`, 0.5, { opacity: 1, y: 0 });
        const tweenA5 = TweenMax.to(`.right_content .newword`, 0.5, { opacity: 1, y: 0 });

        timelineA1.add(tweenA1, 0).add(tweenA2, 0).add(tweenA3, 0.5).add(tweenA4, 1).add(tweenA5, 1.5);
        sceneA1.setTween(timelineA1);
        controller.addScene(sceneA1);
    }, []);

    return isMobile ? (
        <div className={`${styled.story_mobiledesc} content`}>
            <div className="header">
                <h5 className="screen-title">{t('describe.newword')}</h5>
                <h5 className="screen-desc">{t('describe.newwordjp')}</h5>
            </div>
            <div className="text">
                <p className="parag">{t('describe.paraga')}</p>
                <p className="parag">{t('describe.paragb')}</p>
                <p className="parag">{t('describe.paragc')}</p>
            </div>
            <div className="img_box">
                <Image src="/img/stories/common/world/newworld.jpg" layout="fill" className="fullImgs" alt="" aria-label="" />
            </div>
        </div>
    ) : (
        <div className={`${styled.story_desc} storyDesc content`}>
            <div className="img_box">
                <Image src="/img/stories/common/world/newworld.jpg" layout="fill" className="fullImgs" alt="" aria-label="" />
            </div>
            <div className="right_content">
                <p className="parag paraga">{t('describe.paraga')}</p>
                <p className="parag paragb">{t('describe.paragb')}</p>
                <p className="parag paragc">{t('describe.paragc')}</p>
                <h5 className="newword">{t('describe.newword')}</h5>
                <p className="newword">{t('describe.newwordjp')}</p>
            </div>
        </div>
    );
};

export default StoryDescribe;
